import { INVENTORY_MODULE } from "@/api_framework/api_config";
import { IShrinkUpdatePostBody, IShrinkUpdatePostResponse } from "@/api_framework/api_modals/Inventory";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useLoaderActions } from "@/app/hooks/useLoaderActions";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";

AxiosCurlirize(axios, () => {});
export const useShrinkUpdateAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();
  const [status, setStatus] = useState<boolean>();
  const { disable, enable } = useLoaderActions("isInventoryProductMoveGoodToBadInProgress");

  const execute = useCallback(
    async (shrink: IShrinkUpdatePostBody, setInvisible) => {
      enable();
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        if (!shrink) {
          return;
        }
        await axios
          .post(`${INVENTORY_MODULE?.SHRINK_UPDATE?.baseURL}`, JSON.stringify(shrink), {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IShrinkUpdatePostResponse>) => {
            disable();
            if (res.data.status === true) {
              toast.success(`Shrinked`);
              setInvisible();
              setStatus(true);
            } else {
              toast.error("Cannot shrinked.");
              setStatus(false);
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
          });
      } catch (error) {
        disable();
        // Handle errors
        setStatus(false);
        if (axios.isAxiosError(error)) {
          captureError(error);
        } else {
          toast.error("Server Error: " + error.message);
        }
      }
    },
    [dispatch, configuration],
  );

  return { execute, status };
};
